/*
 * <lp-swipe-match> (sections/lp-swipe-match.liquid): Kartenstapel „Desliza y encuentra tu match“.
 * Rechts ziehen = me gusta (Stempel), links = pasar; Buttons ↶/✕/♥ und Pfeiltasten. Likes landen in „Tu lista“
 * (Agregar per window.LpCart, „Agregar todo“ für Produkte mit einer Variante, sonst Link aufs Produkt).
 * Likes und gesehene Karten liegen in localStorage (lp-swipe-match:v1), der Stapel geht beim nächsten Besuch weiter.
 * Einträge der Liste lassen sich einzeln entfernen oder alle leeren, jeweils mit „Deshacer“.
 * Produktdaten aus <script type="application/json" data-items>, Texte aus data-Attributen, höchstens vier Karten im DOM.
 * PostHog-Events (swipe_match_*) nur mit Consent, über die Capture-API ohne SDK.
 * Port von store-us assets/lp-swipe-match.js.
 */
(() => {
  if (customElements.get('lp-swipe-match')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fill = (s, map) => String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const TILTS = [-3, 2.5, -1.5, 3.5, -2.5, 2, -3.5, 1.5, -2, 3, -1, 2.5, -2.5, 1, -3, 3.5, -1.5, 2, -2, 3];
  const KEY = 'lp-swipe-match:v1';
  const SEEN_MAX = 600;

  /* ---------- Speicher (localStorage, ohne Speicher nur im RAM) ---------- */
  const load = () => {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || '{}');
      return { likes: Array.isArray(s.likes) ? s.likes.filter((l) => l && l.h) : [], seen: Array.isArray(s.seen) ? s.seen : [] };
    } catch (err) {
      return { likes: [], seen: [] };
    }
  };
  const save = (state) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ likes: state.likes, seen: state.seen.slice(-SEEN_MAX) }));
    } catch (err) { /* privat oder voll: bleibt im RAM */ }
  };

  /* ---------- Tracking (PostHog Capture-API, nur mit Consent) ---------- */
  const consent = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return Promise.resolve(null);
    return new Promise((resolve) => {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => resolve(error ? null : window.Shopify.customerPrivacy));
    });
  };
  const tracker = (key, host, base) => {
    if (!key) return () => {};
    host = (host || 'https://us.i.posthog.com').replace(/\/$/, '');
    let privacy = null;
    let buf = [];
    let timer = 0;
    consent().then((p) => { privacy = p; }).catch(() => {});
    const vid = () => {
      try {
        let id = localStorage.getItem('lp-swipe-match:vid');
        if (!id) {
          id = `lpsm-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
          localStorage.setItem('lp-swipe-match:vid', id);
        }
        return id;
      } catch (err) {
        return 'lpsm-anon';
      }
    };
    const flush = () => {
      clearTimeout(timer);
      const allowed = privacy?.userCanBeTracked?.();
      const events = buf.splice(0);
      if (!allowed || !events.length) return;
      try {
        if (window.posthog?.capture) {
          events.forEach((e) => window.posthog.capture(e.event, e.properties));
          return;
        }
        const id = vid();
        const json = JSON.stringify(events.map((e) => ({ ...e, properties: { ...e.properties, token: key, distinct_id: id, $process_person_profile: false } })));
        let bin = '';
        new TextEncoder().encode(json).forEach((b) => { bin += String.fromCharCode(b); });
        const url = `${host}/e/?compression=base64`;
        const body = new URLSearchParams({ data: btoa(bin) });
        if (!navigator.sendBeacon?.(url, body)) fetch(url, { method: 'POST', body, keepalive: true }).catch(() => {});
      } catch (err) { /* Tracking bricht nie die Sektion */ }
    };
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
    return (event, props = {}) => {
      try {
        buf.push({
          event,
          properties: { ...base, ...props, device: innerWidth < 700 ? 'mobile' : 'desktop', $current_url: location.href, $pathname: location.pathname, $lib: 'lp-swipe-match' },
          timestamp: new Date().toISOString(),
        });
        if (buf.length > 100) buf.shift();
        clearTimeout(timer);
        timer = setTimeout(flush, 2000);
      } catch (err) { /* egal */ }
    };
  };

  class LpSwipeMatch extends HTMLElement {
    connectedCallback() {
      if (this.lpReady) return;
      if (!this.querySelector('[data-deck]')) return;
      this.lpReady = true;
      const root = this;
      const t = this.dataset;
      const $ = (s) => root.querySelector(s);
      let pool = [];
      try { pool = JSON.parse($('[data-items]')?.textContent || '[]'); } catch (err) { pool = []; }
      const byHandle = new Map(pool.map((p) => [p.h, p]));

      const deckEl = $('[data-deck]');
      const cardTpl = $('[data-card-tpl]');
      const miniTpl = $('[data-mini-tpl]');
      const endCard = $('[data-end]');
      const undoBtn = $('[data-undo]');
      const noBtn = $('[data-no]');
      const yesBtn = $('[data-yes]');
      const counter = $('[data-counter]');
      const live = $('[data-live]');
      const tray = $('[data-tray]');
      const trayTitle = $('[data-tray-title]');
      const list = $('[data-list]');
      const empty = $('[data-empty]');
      const countEl = $('[data-count]');
      const allBtn = $('[data-all]');
      const expandBtn = $('[data-expand]');
      const foot = $('[data-foot]');
      const clearBtn = $('[data-clear]');
      const rail = $('[data-rail]');
      const nav = $('[data-nav]');
      const prevBtn = $('[data-prev]');
      const nextBtn = $('[data-next]');
      const endTitle = endCard.querySelector('[data-end-title]');
      const endText = endCard.querySelector('[data-end-text]');
      const endFan = endCard.querySelector('[data-end-fan]');
      const hint = $('[data-hint]');
      const toast = $('[data-toast]');
      const toastText = $('[data-toast-text]');
      const toastUndo = $('[data-toast-undo]');
      const track = tracker(t.posthogKey, t.posthogHost, { section_id: t.sectionId });

      const state = load();
      let deck = [];          // Karten dieser Runde (Pool ohne gesehene und gemerkte)
      let index = 0;
      let history = [];       // Entscheidungen dieser Sitzung für ↶
      let roundLikes = 0;
      let startedEmpty = false;
      let busy = false;
      let drag = null;
      let raf = 0;
      let hinted = false;
      let expanded = false;
      const cardEls = new Map(); // Position im Stapel → <article>
      const minis = new Map();   // Handle → <li>

      const persist = () => save(state);
      const isLiked = (h) => state.likes.some((l) => l.h === h);
      const markSeen = (h) => { if (!state.seen.includes(h)) state.seen.push(h); };
      const unmarkSeen = (h) => { state.seen = state.seen.filter((x) => x !== h); };
      const buildDeck = () => {
        const seen = new Set(state.seen);
        deck = pool.filter((p) => !seen.has(p.h) && !isLiked(p.h));
      };
      const snapshot = (p) => ({ h: p.h, pid: p.pid, id: p.id, single: p.single, url: p.url, title: p.title, price: p.price, img: p.thumb || p.img });

      /* ---------- Karten ---------- */
      const makeCard = (pos) => {
        const p = deck[pos];
        const el = cardTpl.content.firstElementChild.cloneNode(true);
        el.dataset.pos = pos;
        el.style.setProperty('--r', `${TILTS[pos % TILTS.length]}deg`);
        el.style.setProperty('--d', 3);
        const img = el.querySelector('[data-img]');
        if (pos - index < 2) img.loading = 'eager';
        img.srcset = `${p.img.replace('width=600', 'width=300')} 300w, ${p.img} 600w`;
        img.src = p.img;
        img.alt = p.title;
        el.querySelector('[data-tag]').textContent = p.label || '';
        el.querySelector('[data-name]').textContent = p.title;
        el.querySelector('[data-price]').textContent = p.price;
        const cmp = el.querySelector('[data-cmp]');
        if (p.cmp) cmp.textContent = p.cmp; else cmp.remove();
        const more = el.querySelector('[data-more]');
        more.href = p.url;
        more.setAttribute('aria-label', `${t.seeDetails}: ${p.title}`);
        more.addEventListener('click', () => track('swipe_match_details', { product_id: p.pid, handle: p.h, position: pos }));
        deckEl.insertBefore(el, endCard);
        cardEls.set(pos, el);
        return el;
      };

      // Nur die obersten vier Karten im DOM; weggewischte werden nach der Animation entfernt
      const sync = () => {
        for (let pos = index; pos < Math.min(deck.length, index + 4); pos++) {
          if (!cardEls.has(pos)) makeCard(pos);
        }
        cardEls.forEach((el, pos) => {
          if (pos >= index + 4) { el.remove(); cardEls.delete(pos); }
        });
      };

      const layout = () => {
        sync();
        const n = deck.length;
        cardEls.forEach((el, pos) => {
          const d = pos - index;
          if (d < 0) {
            el.classList.remove('is-top');
            el.setAttribute('aria-hidden', 'true');
            el.inert = true;
            return;
          }
          el.style.setProperty('--d', Math.min(d, 3));
          el.classList.toggle('is-top', d === 0);
          el.classList.toggle('is-hidden', d > 2);
          el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
          el.inert = d !== 0;
        });
        const de = n - index;
        endCard.style.setProperty('--d', Math.min(de, 3));
        endCard.classList.toggle('is-top', de === 0);
        endCard.classList.toggle('is-hidden', de > 2);
        endCard.setAttribute('aria-hidden', de === 0 ? 'false' : 'true');
        endCard.inert = de !== 0;
        counter.textContent = index < n ? `${index + 1} / ${n}` : t.allDone;
        noBtn.disabled = yesBtn.disabled = index >= n;
        undoBtn.disabled = !history.length;
        refreshEnd();
      };

      const refreshEnd = () => {
        const c = roundLikes;
        if (startedEmpty && !history.length) {
          endTitle.textContent = t.endSeen;
          endText.textContent = t.endSeenText;
        } else {
          endTitle.textContent = c ? (c === 1 ? t.endOne : fill(t.endOther, { count: c })) : t.endNone;
          endText.textContent = c ? t.endText : t.endNoneText;
        }
        endFan.replaceChildren(...state.likes.slice(-3).map((m) => {
          const img = new Image();
          img.src = m.img;
          img.alt = '';
          img.width = img.height = 200;
          return img;
        }));
      };

      const hideHint = () => {
        if (hint) hint.classList.remove('is-on');
        cardEls.get(index)?.classList.remove('is-hint');
      };

      const pop = (btn) => {
        if (reduce || !btn.animate) return;
        btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(.84)' }, { transform: 'scale(1.1)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
      };

      // Herzen fliegen aus dem ♥-Button
      const burst = () => {
        if (reduce || !yesBtn.animate) return;
        const svg = yesBtn.querySelector('svg');
        for (let k = 0; k < 7; k++) {
          const s = document.createElement('span');
          s.className = `lp-swipe__spark${k % 2 ? ' is-pink' : ''}`;
          s.setAttribute('aria-hidden', 'true');
          s.append(svg.cloneNode(true));
          yesBtn.append(s);
          const a = ((-90 + (k - 3) * 24) * Math.PI) / 180;
          const dist = 48 + Math.random() * 34;
          s.animate(
            [
              { transform: 'translate(-50%, -50%) scale(.3)', opacity: 1 },
              { transform: `translate(calc(-50% + ${Math.cos(a) * dist}px), calc(-50% + ${Math.sin(a) * dist}px)) scale(${0.6 + Math.random() * 0.5}) rotate(${(k - 3) * 14}deg)`, opacity: 0 },
            ],
            { duration: 650 + k * 40, easing: 'cubic-bezier(.2,.8,.2,1)' },
          ).onfinish = () => s.remove();
        }
      };

      const cartAdd = (items, button, images, event) => {
        if (!window.LpCart) return;
        track(event, { list_size: state.likes.length, count: items.length, handles: items.map((m) => m.h) });
        Promise.resolve(window.LpCart.add({ body: items.map((m) => ({ id: Number(m.id), quantity: 1 })), button, images })).catch(() => {});
      };

      /* ---------- Liste ---------- */
      const syncRail = () => {
        const max = list.scrollWidth - list.clientWidth;
        const x = Math.abs(list.scrollLeft);
        const can = !expanded && state.likes.length > 0 && max > 2;
        nav.hidden = !can;
        prevBtn.disabled = x <= 2;
        nextBtn.disabled = x >= max - 2;
        rail.classList.toggle('is-more', can && x < max - 2);
        rail.classList.toggle('is-less', can && x > 2);
      };
      // Seitenweise um ganze Karten blättern
      const page = (dir) => {
        const item = list.firstElementChild;
        if (!item) return;
        const step = item.offsetWidth + parseFloat(getComputedStyle(list).columnGap || 0);
        const per = Math.max(1, Math.floor((list.clientWidth + 1) / step));
        list.scrollBy({ left: dir * per * step, behavior: reduce ? 'auto' : 'smooth' });
      };
      prevBtn.addEventListener('click', () => page(-1));
      nextBtn.addEventListener('click', () => page(1));
      list.addEventListener('scroll', () => requestAnimationFrame(syncRail), { passive: true });
      if (window.ResizeObserver) new ResizeObserver(syncRail).observe(list);

      const makeMini = (m) => {
        const li = miniTpl.content.firstElementChild.cloneNode(true);
        li.dataset.h = m.h;
        const link = li.querySelector('[data-mini-link]');
        link.href = m.url;
        link.setAttribute('aria-label', m.title);
        const img = li.querySelector('[data-mini-img]');
        img.src = m.img;
        li.querySelector('[data-mini-name]').textContent = m.title;
        const rm = li.querySelector('[data-remove]');
        rm.setAttribute('aria-label', fill(t.removeLabel, { title: m.title }));
        rm.addEventListener('click', () => remove(m.h));
        li.addEventListener('animationend', () => li.classList.remove('is-new'));
        fillMini(li, m);
        return li;
      };

      // Preis und Aktion (Agregar / Opciones / nicht mehr verfügbar) neu setzen
      const fillMini = (li, m) => {
        li.querySelector('[data-mini-price]').textContent = m.off ? '' : m.price;
        li.classList.toggle('is-off', Boolean(m.off));
        li.querySelector('.lp-swipe__add, .lp-swipe__off')?.remove();
        const img = li.querySelector('[data-mini-img]');
        let el;
        if (m.off) {
          el = Object.assign(document.createElement('span'), { className: 'lp-swipe__off', textContent: t.unavailable });
        } else if (m.single) {
          el = Object.assign(document.createElement('button'), { type: 'button', className: 'lp-swipe__add', textContent: t.add });
          el.setAttribute('aria-label', fill(t.addLabel, { title: m.title }));
          el.addEventListener('click', () => cartAdd([m], el, [img], 'swipe_match_add_to_cart'));
        } else {
          el = Object.assign(document.createElement('a'), { href: m.url, className: 'lp-swipe__add lp-swipe__add--link', textContent: t.options });
          el.setAttribute('aria-label', fill(t.optionsLabel, { title: m.title }));
        }
        li.append(el);
      };

      const mini = (m) => {
        let li = minis.get(m.h);
        if (!li) { li = makeMini(m); minis.set(m.h, li); }
        return li;
      };

      // Neueste zuerst; vorhandene <li> werden wiederverwendet
      const renderTray = () => {
        const keep = new Set(state.likes.map((m) => m.h));
        minis.forEach((li, h) => { if (!keep.has(h)) { li.remove(); minis.delete(h); } });
        const order = state.likes.slice().reverse().map(mini);
        order.forEach((li) => li.classList.remove('is-removing'));
        order.forEach((li, i) => { if (list.children[i] !== li) list.insertBefore(li, list.children[i] || null); });
        const singles = state.likes.filter((m) => m.single && !m.off);
        const c = state.likes.length;
        countEl.textContent = c;
        root.classList.toggle('has-matches', c > 0);
        empty.hidden = c > 0;
        foot.hidden = c === 0;
        allBtn.hidden = singles.length < 2;
        if (c <= 3 && expanded) setExpanded(false);
        expandBtn.hidden = c <= 3;
        expandBtn.textContent = expanded ? t.showLess : t.showAll;
        syncRail();
      };

      const setExpanded = (on) => {
        expanded = on;
        tray.classList.toggle('is-expanded', on);
        expandBtn.setAttribute('aria-expanded', String(on));
        expandBtn.textContent = on ? t.showLess : t.showAll;
        if (!on) list.scrollTo({ left: 0 });
        syncRail();
      };
      expandBtn.addEventListener('click', () => {
        setExpanded(!expanded);
        if (!expanded) trayTitle.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      });

      /* ---------- Hinweis mit Deshacer ---------- */
      let toastTimer = 0;
      let toastAction = null;
      const showToast = (text, undo) => {
        clearTimeout(toastTimer);
        toastText.textContent = text;
        toastAction = undo;
        toast.classList.add('is-on');
        toastTimer = setTimeout(hideToast, 5000);
      };
      const hideToast = () => {
        clearTimeout(toastTimer);
        toastAction = null;
        toast.classList.remove('is-on');
      };
      toastUndo.addEventListener('click', () => {
        const fn = toastAction;
        hideToast();
        fn?.();
      });

      const focusAfterRemove = (i) => {
        const items = [...list.children].filter((li) => !li.classList.contains('is-removing'));
        const next = items[Math.min(i, items.length - 1)];
        (next ? next.querySelector('[data-remove]') : trayTitle).focus({ preventScroll: true });
      };

      const remove = (h) => {
        const i = state.likes.findIndex((l) => l.h === h);
        if (i < 0) return;
        const [m] = state.likes.splice(i, 1);
        persist();
        const li = minis.get(h);
        const domIndex = li ? [...list.children].indexOf(li) : 0;
        const done = () => {
          // Per Deshacer schon zurück: <li> bleibt
          if (!isLiked(h)) { minis.delete(h); li?.remove(); }
          renderTray();
          refreshEnd();
        };
        if (li && !reduce) {
          li.classList.add('is-removing');
          setTimeout(done, 250);
        } else done();
        focusAfterRemove(domIndex);
        live.textContent = t.removed;
        track('swipe_match_remove', { product_id: m.pid, handle: m.h, list_size: state.likes.length });
        showToast(t.removed, () => {
          if (isLiked(m.h)) return;
          state.likes.splice(Math.min(i, state.likes.length), 0, m);
          persist();
          renderTray();
          refreshEnd();
          minis.get(m.h)?.querySelector('[data-remove]').focus({ preventScroll: true });
          track('swipe_match_remove_undo', { product_id: m.pid, handle: m.h, list_size: state.likes.length });
        });
      };

      clearBtn.addEventListener('click', () => {
        const before = state.likes.slice();
        if (!before.length) return;
        state.likes = [];
        persist();
        if (expanded) setExpanded(false);
        renderTray();
        refreshEnd();
        trayTitle.focus({ preventScroll: true });
        live.textContent = t.cleared;
        track('swipe_match_clear', { list_size: before.length });
        showToast(t.cleared, () => {
          const now = new Set(state.likes.map((l) => l.h));
          state.likes = [...before.filter((l) => !now.has(l.h)), ...state.likes];
          persist();
          renderTray();
          refreshEnd();
          track('swipe_match_clear_undo', { list_size: state.likes.length });
        });
      });

      allBtn.addEventListener('click', () => {
        const singles = state.likes.filter((m) => m.single && !m.off);
        if (singles.length) cartAdd(singles, allBtn, singles.map((m) => minis.get(m.h)?.querySelector('img')).filter(Boolean), 'swipe_match_add_all');
      });

      /* ---------- Entscheiden, Rückgängig ---------- */
      const threshold = () => Math.min(120, deckEl.offsetWidth * 0.3);

      const decide = (dir, d) => {
        if (busy || index >= deck.length) return;
        busy = true;
        hideHint();
        hideToast();
        const pos = index;
        const p = deck[pos];
        const card = cardEls.get(pos);
        const dy = d ? d.dy * 0.25 : 0;
        card.style.setProperty('--yes', dir > 0 ? 1 : 0);
        card.style.setProperty('--no', dir > 0 ? 0 : 1);
        card.classList.add('is-leaving');
        card.style.transition = reduce ? 'none' : 'transform .5s cubic-bezier(.3,.6,.35,1), opacity .5s cubic-bezier(.7,0,1,1)';
        const out = root.offsetWidth * 0.6 + card.offsetWidth;
        requestAnimationFrame(() => {
          card.style.transform = `translate3d(${dir * out}px, ${dy + 70}px, 0) rotate(${dir * 28}deg)`;
          card.style.opacity = '0';
        });
        deckEl.style.setProperty('--lift', 1);
        live.textContent = fill(dir > 0 ? t.matched : t.skipped, { title: p.title });
        markSeen(p.h);
        if (dir > 0) {
          if (!isLiked(p.h)) state.likes.push({ ...snapshot(p), at: Date.now() });
          roundLikes += 1;
          const li = mini(state.likes[state.likes.length - 1]);
          li.classList.add('is-new');
          renderTray();
          list.scrollTo({ left: 0, behavior: reduce || !list.scrollLeft ? 'auto' : 'smooth' });
          burst();
        }
        persist();
        history.push({ pos, dir });
        track(dir > 0 ? 'swipe_match_like' : 'swipe_match_skip', {
          product_id: p.pid, handle: p.h, position: pos, via: d ? 'drag' : 'button', list_size: state.likes.length, deck_left: deck.length - pos - 1,
        });
        setTimeout(() => {
          index += 1;
          layout();
          deckEl.style.setProperty('--lift', 0);
          busy = false;
          if (index >= deck.length && [noBtn, yesBtn, deckEl].includes(document.activeElement)) endCard.querySelector('[data-restart]').focus({ preventScroll: true });
        }, reduce ? 0 : 230);
        setTimeout(() => {
          card.classList.add('is-out');
          // Weggewischte Karte aus dem DOM, sofern sie nicht per ↶ zurückkam
          if (index > pos && cardEls.get(pos) === card) { card.remove(); cardEls.delete(pos); }
        }, reduce ? 0 : 520);
      };

      const undo = () => {
        if (busy || !history.length) return;
        const { pos, dir } = history.pop();
        const p = deck[pos];
        hideHint();
        hideToast();
        busy = true;
        cardEls.get(pos)?.remove();
        cardEls.delete(pos);
        unmarkSeen(p.h);
        if (dir > 0) {
          state.likes = state.likes.filter((l) => l.h !== p.h);
          roundLikes = Math.max(0, roundLikes - 1);
          renderTray();
        }
        persist();
        index = pos;
        const card = makeCard(pos);
        card.style.transition = 'none';
        card.style.transform = `translate3d(${dir * (root.offsetWidth * 0.6 + 260)}px, 70px, 0) rotate(${dir * 28}deg)`;
        card.style.opacity = '0';
        layout();
        void card.offsetWidth;
        card.style.transition = reduce ? 'none' : 'transform .45s cubic-bezier(.3,1.2,.5,1), opacity .25s var(--lp-ease)';
        card.style.transform = '';
        card.style.opacity = '';
        live.textContent = fill(t.undone, { title: p.title });
        track('swipe_match_undo', { product_id: p.pid, handle: p.h, position: pos, was: dir > 0 ? 'like' : 'skip', list_size: state.likes.length });
        setTimeout(() => { card.style.transition = ''; busy = false; }, reduce ? 0 : 460);
      };

      const springBack = () => {
        const card = cardEls.get(index);
        card.style.transition = reduce ? 'none' : 'transform .6s cubic-bezier(.34,1.56,.64,1)';
        card.style.transform = '';
        card.style.setProperty('--yes', 0);
        card.style.setProperty('--no', 0);
        deckEl.style.setProperty('--lift', 0);
        setTimeout(() => { card.style.transition = ''; }, 620);
      };

      const act = (dir) => {
        if (busy || index >= deck.length) return;
        pop(dir > 0 ? yesBtn : noBtn);
        decide(dir, null);
      };

      /* ---------- Geste: Pointer Events; vertikal bleibt beim Browser (touch-action: pan-y) ---------- */
      const paint = () => {
        raf = 0;
        if (!drag) return;
        const card = cardEls.get(index);
        const p = Math.max(-1, Math.min(1, drag.dx / threshold()));
        card.style.transform = `translate3d(${drag.dx}px, ${drag.dy * 0.25}px, 0) rotate(${drag.dx * 0.06}deg)`;
        card.style.setProperty('--yes', Math.max(0, p));
        card.style.setProperty('--no', Math.max(0, -p));
        deckEl.style.setProperty('--lift', Math.abs(p) * 0.6);
      };

      deckEl.addEventListener('pointerdown', (e) => {
        const card = cardEls.get(index);
        if (busy || !card || !card.contains(e.target) || (e.pointerType === 'mouse' && e.button !== 0)) return;
        drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, dy: 0, on: false, lx: e.clientX, lt: e.timeStamp, vx: 0 };
      });

      deckEl.addEventListener('pointermove', (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const dx = e.clientX - drag.x0;
        const dy = e.clientY - drag.y0;
        if (!drag.on) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          drag.on = true;
          const card = cardEls.get(index);
          card.style.transition = '';
          try { card.setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
          root.classList.add('is-dragging');
          hideHint();
        }
        const dt = e.timeStamp - drag.lt;
        if (dt > 0) {
          drag.vx = 0.7 * ((e.clientX - drag.lx) / dt) + 0.3 * drag.vx;
          drag.lx = e.clientX;
          drag.lt = e.timeStamp;
        }
        drag.dx = dx;
        drag.dy = dy;
        if (!raf) raf = requestAnimationFrame(paint);
      });

      const end = (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const d = drag;
        drag = null;
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        if (!d.on) return;
        root.classList.remove('is-dragging');
        const card = cardEls.get(index);
        card.dataset.dragged = '1';
        setTimeout(() => { delete card.dataset.dragged; }, 80);
        const flick = Math.abs(d.vx) > 0.55 && Math.sign(d.vx) === Math.sign(d.dx) && Math.abs(d.dx) > 24;
        if (e.type !== 'pointercancel' && (Math.abs(d.dx) > threshold() || flick)) decide(d.dx > 0 ? 1 : -1, d);
        else springBack();
      };
      deckEl.addEventListener('pointerup', end);
      deckEl.addEventListener('pointercancel', end);
      // Nach dem Ziehen keinen Klick auf „Ver“ auslösen
      deckEl.addEventListener('click', (e) => {
        const c = e.target.closest('[data-card]');
        if (c && c.dataset.dragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      deckEl.addEventListener('dragstart', (e) => e.preventDefault());

      undoBtn.addEventListener('click', () => { pop(undoBtn); undo(); });
      noBtn.addEventListener('click', () => act(-1));
      yesBtn.addEventListener('click', () => act(1));
      root.addEventListener('keydown', (e) => {
        if (e.altKey || e.metaKey || e.ctrlKey || e.target.closest('[data-tray], [data-toast]')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); act(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); act(1); }
      });

      /* ---------- Austeilen, Neustart ---------- */
      const deal = (then) => {
        if (reduce) { then?.(); return; }
        root.classList.add('is-dealing');
        root.classList.remove('is-dealt');
        void deckEl.offsetWidth;
        requestAnimationFrame(() => {
          root.classList.add('is-dealt');
          setTimeout(() => { root.classList.remove('is-dealing', 'is-dealt'); then?.(); }, 900);
        });
      };

      const nudge = () => {
        if (hinted || reduce || index >= deck.length || drag || history.length) return;
        hinted = true;
        cardEls.get(index)?.classList.add('is-hint');
        hint?.classList.add('is-on');
        setTimeout(hideHint, 3200);
      };

      endCard.querySelector('[data-restart]').addEventListener('click', () => {
        track('swipe_match_restart', { list_size: state.likes.length, seen: state.seen.length });
        state.seen = [];
        persist();
        cardEls.forEach((el) => el.remove());
        cardEls.clear();
        buildDeck();
        index = 0;
        history = [];
        roundLikes = 0;
        startedEmpty = false;
        layout();
        deal();
        deckEl.focus({ preventScroll: true });
      });

      /* ---------- Gespeicherte Likes auffrischen ---------- */
      // Im Pool: Daten von der Seite. Sonst einmal pro Sitzung /products/<handle>.js (höchstens drei gleichzeitig).
      const refreshLikes = () => {
        state.likes.forEach((l) => {
          const p = byHandle.get(l.h);
          if (p) Object.assign(l, snapshot(p), { off: false });
        });
        let done;
        try { done = new Set(JSON.parse(sessionStorage.getItem('lp-swipe-match:fresh') || '[]')); } catch (err) { done = new Set(); }
        const todo = state.likes.filter((l) => !byHandle.has(l.h) && !done.has(l.h));
        const money = window.LpCart?.money || ((c) => `$${Math.round(c / 100).toLocaleString('es-CO')}`);
        const one = async (l) => {
          try {
            const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(l.h)}.js`);
            if (res.status === 404) { l.off = true; return; }
            if (!res.ok) return;
            const prod = await res.json();
            const v = prod.variants.find((x) => x.id === Number(l.id)) || prod.variants.find((x) => x.available) || prod.variants[0];
            Object.assign(l, { id: v.id, single: prod.variants.length === 1, url: prod.url || l.url, title: prod.title, price: money(v.price), off: !prod.available });
          } catch (err) { return; }
          done.add(l.h);
        };
        const run = async () => {
          while (todo.length) await one(todo.shift());
        };
        return Promise.all([run(), run(), run()]).then(() => {
          try { sessionStorage.setItem('lp-swipe-match:fresh', JSON.stringify([...done])); } catch (err) { /* egal */ }
          state.likes.forEach((l) => { const li = minis.get(l.h); if (li) fillMini(li, l); });
          persist();
          renderTray();
        });
      };

      // Andere Tabs: Liste übernehmen, Stapel nicht umbauen
      window.addEventListener('storage', (e) => {
        if (e.key !== KEY) return;
        const s = load();
        state.likes = s.likes;
        state.seen = s.seen;
        renderTray();
        refreshEnd();
      });

      /* ---------- Start ---------- */
      buildDeck();
      startedEmpty = deck.length === 0;
      layout();
      renderTray();
      refreshLikes();

      if (!reduce) root.classList.add('is-dealing');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          root.classList.toggle('is-live', en.isIntersecting);
          if (en.isIntersecting && en.intersectionRatio >= 0.3 && !root.dataset.dealt) {
            root.dataset.dealt = '1';
            track('swipe_match_viewed', { pool_size: pool.length, deck_left: deck.length, list_size: state.likes.length });
            deal(() => setTimeout(nudge, 250));
          }
        });
      }, { threshold: [0, 0.3] });
      io.observe(deckEl);
    }
  }

  customElements.define('lp-swipe-match', LpSwipeMatch);
})();
